export const SECTORS = [
  'Logistics & Transport', 'Healthcare', 'Education', 'Retail', 'Finance & Insurance',
  'Manufacturing', 'Public Sector', 'Technology', 'Construction', 'Hospitality', 'Other',
];

export const ORGANISATION_SIZES = [
  { value: '1-49', label: '1–49 employees' },
  { value: '50-249', label: '50–249 employees' },
  { value: '250-999', label: '250–999 employees' },
  { value: '1000+', label: '1,000+ employees' },
];

export const DC_LEVELS = [
  { value: 0, label: 'Level 0 — Not started' },
  { value: 1, label: 'Level 1 — Committed' },
  { value: 2, label: 'Level 2 — Employer' },
  { value: 3, label: 'Level 3 — Leader' },
];

export const CONTRAST_MODES = [
  { value: 'standard', label: 'Standard' },
  { value: 'high-contrast', label: 'High contrast' },
  { value: 'dark', label: 'Dark mode' },
];

export const TEXT_SIZES = [
  { value: 'normal', label: 'Normal' },
  { value: 'large', label: 'Large' },
  { value: 'extra-large', label: 'Extra large' },
];

export function profileForm(customer = {}) {
  const defaults = customer.accessibility_defaults || {};
  return {
    name: customer.name || '', sector: customer.sector || '', size: customer.size || '',
    logo_url: customer.logo_url || '', current_dc_level: String(customer.current_dc_level ?? 0),
    evidence_retention_years: String(customer.evidence_retention_years ?? 6),
    contrastMode: defaults.contrastMode || 'standard', textSize: defaults.textSize || 'normal',
    reduceMotion: !!defaults.reduceMotion,
  };
}

export function profilePayload(form, existingDefaults = {}) {
  return {
    name: form.name.trim(), sector: form.sector || null, size: form.size || null,
    logo_url: form.logo_url.trim() || null, current_dc_level: Number(form.current_dc_level),
    evidence_retention_years: Number(form.evidence_retention_years),
    accessibility_defaults: {
      ...existingDefaults, contrastMode: form.contrastMode, textSize: form.textSize,
      reduceMotion: form.reduceMotion,
    },
  };
}
